import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RolePermissionService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private rolesPermissionsData: any;
  permissions$ = new BehaviorSubject<string[]>([]);

  constructor(private http: HttpClient) {}

  loadPermissions(userRoles: string[]): Observable<void> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.http.get<any>('/assets/role-permissions.json').pipe(
      tap(res => {
        this.rolesPermissionsData = res.roles || {};

        const permissions = userRoles.flatMap(
          role => this.rolesPermissionsData[role]?.permissions || []
        );
        const uniquePermissions = Array.from(new Set(permissions));
        this.setPermissions(uniquePermissions);
      }),
      map(() => void 0)
    );
  }

  setPermissions(permissions: string[]) {
    this.permissions$.next(permissions);
  }

  getPermissions(): Observable<string[]> {
    return this.permissions$.asObservable();
  }

  hasPermission(permission: string): boolean {
    const perms = this.permissions$.value;
    return perms.includes(permission);
  }
}
